// src/pages/Services.js
import React from 'react'
import Back2School4 from "../app/images/schoolshoppinglist4.png";

const Services = () => {
  return (
    <div className="container">
	  <h1 className="is-size-3 has-text-weight-bold has-text-danger has-text-centered">Our Services</h1>
	  <img src={Back2School4} className="img_responsive" alt="Back to School Shopping List" title="Back to School Shopping List" />

	  <p>Quarterdeck clipper parley yardarm gally barque galleon. Bring a spring upon her cable gunwalls Shiver me timbers pink scurvy fore barque. </p>
    <p>Keelhaul clap of thunder Privateer black jack jack black spot weigh anchor. Lookout boatswain Corsair coffer square-rigged ye bilged on her anchor. </p>
    <p>Tack boatswain pink topsail run a shot across the bow topgallant gibbet. Topgallant avast hogshead jib grog sloop cutlass.  </p>
	</div>
  )
}

export default Services
